function StatCard({ icon, img, angka, label, warna, trend, trendArah }) {
  return (
    <div className={`stat-card ${warna}`}>
      <div className="stat-top">
        <span className="stat-icon">
          {img ? <img src={img} alt="" className="stat-icon-img" /> : icon}
        </span>
        <span className={`stat-trend ${trendArah}`}>{trend}</span>
      </div>
      <div className="stat-angka">{angka}</div>
      <div className="stat-label">{label}</div>
    </div>
  );
}

export default StatCard;